<template>
    <div class="content-img" @click="processClick()">
        <div class="wrapper-img"></div>
        <img v-bind:src="source" v-bind:srcset="source + ' 1x, ' + source2x + ' 2x'" alt=""
             style="vertical-align: middle">
        <div class="wrapper-img"></div>
    </div>
</template>
<style scopped>
    .content-img {
        display: inline-flex;
        flex-direction: column;
        font-size: 0;
    }

    .wrapper-img {
        flex: 1;
    }
</style>

<script>
    export default {
        props: ['src'],
        data() {
            let source = require('../assets' + this.src + '.png');
            let source2x = require('../assets' + this.src + '@2x.png');
            return {
                source: source,
                source2x: source2x
            }
        },
        methods: {
            processClick() {
                this.$emit('click')
            }
        },
        watch: {
            src: function(newVal) {
                let source = require('../assets' + newVal + '.png');
                let source2x = require('../assets' + newVal + '@2x.png');
                this.source = source;
                this.source2x = source2x;
            }
        }
    }
</script>




// WEBPACK FOOTER //
// src/components/AutoIcon.vue